<template>

	<div :class="`${this.direction.length > 0 ? 'show' : ''} popup popup--${ this.direction } popup--${ this.type }`" :style="getStyle()">


		<div class="popup__left">



		</div>

		<div class="popup__middle" :style="`background-color: ${ this.bgcolor }; width: ${ this.width }px; height: ${ this.height }px;`">

			<div class="popup__content">

				<div class="popup__arrow" :style="`background-color: ${ this.bgcolor }`"></div>

				<div class="popup__info">

					<div class="popup__title">

						{{ this.title }}

					</div>

					<div class="popup__text" v-html="this.text">

					</div>

				</div>

				<div class="popup__image">

					<img id="showVideoPopup" v-if="this.image !== ''" :src="image" :alt="title" @click="$parent.startPopupVideo()" />

				</div>

			</div>

		</div>

		<div class="popup__right">



		</div>

	</div>

</template>

<script>

	export default {
		data () {
			return {
				style: ''
			};
		},
		props: [
			'left', 'top', 'width', 'height', 'title', 'text', 'direction', 'image', 'bgcolor', 'type', 'video'
		],
		methods: {
			getStyle () {

				if (this.direction === 'topleft') {
					this.style = `right: ${ 1920 - this.left }px; bottom: ${ 1080 - this.top - (this.height * 0.34) }px;`
				}

				if (this.direction === 'topright') {
					this.style = `left: ${ this.left }px; bottom: ${ 1080 - this.top - (this.height * 0.34) }px;`;
				}

				if (this.direction === 'bottomleft') {
					this.style = `right: ${ 1920 - this.left }px; top: ${ this.top - (this.height * 0.34) }px;`;
				}

				if (this.direction === 'bottomright') {
					this.style = `left: ${ this.left }px; top: ${ this.top - (this.height * 0.34) }px;`;
				}

				return this.style;
			}
		}
	};

</script>